import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {bindActionCreators} from 'redux';
import {FormattedMessage} from 'react-intl';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import {Button, Container, Menu} from 'semantic-ui-react';
import {string, bool, func, shape, object} from 'prop-types';
import * as ResourceApi from 'api/resources';
import {getResourcePageAction} from 'resources/actions';
import ResourceForm from 'components/forms/ResourceForm';
import {filterOptionsFactory} from 'viewOptions/factories';
import {createResourcePageSelector} from 'resources/selectors';
import {createResourceSortOptionsSelector} from 'viewOptions/selectors';
import BasicComponents from 'components/forms/Component Sets/BasicFormComponents';
import {setQueryAction, clearQueryAction, updateQueryAction, registerFieldsAction} from '../actions';
import {buildQueryFilters} from '../utils';
import {ReportTypes} from "../../../api/reports";
import {SEARCH_REQUEST_DEBOUNCE_TIME} from 'Config';

class SearchPanel extends React.Component {
    static propTypes = {
        buildFilters: func,
        redirectUrl: string,
        registerFields: func,
        searchButtonKey: string,
        showExportButton: bool,
        sectionWrapper: func,
        submit: func.isRequired,
        allowClearQuery: bool,
        clearButtonKey: string,
        loading: bool,
        formConfig: object,
        formData: object
    };

    state = {
        waitingForReports: []
    };

    onValueChanged = debounce(this.props.onValueChanged, SEARCH_REQUEST_DEBOUNCE_TIME, {leading: true});

    download = (type) => {
        let waitingFor = this.state.waitingForReports.slice();
        waitingFor.push(type);
        this.setState({
            waitingForReports: waitingFor
        });

        console.log(this.props.formData);

        ResourceApi.download(type, this.props.formData)
            .catch((err) => {
                let responseInfo = {
                    type: type,
                    success: false
                };

                let reportResponses = this.state.reportResponses.slice();
                reportResponses.push(responseInfo);

                let waiting = this.state.waitingForReports.slice();
                waiting.splice(waiting.indexOf(type), 1);
                this.setState({
                    reportResponses: reportResponses,
                    waitingForReports: waiting
                });
            })
            .subscribe((response) => {
                let responseInfo = {
                    type: type,
                    success: true
                };

                let reportResponses = this.state.reportResponses.slice();
                reportResponses.push(responseInfo);

                let waiting = this.state.waitingForReports.slice();
                waiting.splice(waiting.indexOf(type), 1);
                this.setState({
                    reportResponses: reportResponses,
                    waitingForReports: waiting
                });
            });
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.fields.length && nextProps.fields.length) {
            // register dynamically generated form fields with Redux so we can
            // select/clear all values before the user has touched them.
            this.props.registerFields(nextProps.fields);
        }
    }

    render() {
        return (
            <div className='user-management-search-panel'>
              <ResourceForm
                errors={this.props.errors}
                components={BasicComponents}
                config={this.props.formConfig}
                resource={this.props.formData}
                onValueChanged={this.onValueChanged}
                sectionWrapper={this.props.sectionWrapper}
                onValidationError={this.props.onValidationError} />
              <br/>
              <Container textAlign='right' className='search-panel-actions'>
                {this.props.allowClearQuery && (
                  <Button
                    secondary
                    onClick={this.props.clearQuery}
                    loading={this.props.loading}>
                    <FormattedMessage id={this.props.clearButtonKey} />
                  </Button>
                )}
                {this.props.showExportButton && (
                    <Button
                      primary
                      onClick={() => {
                          this.download(ReportTypes.UserReport);
                      }}
                      loading={this.props.loading}>
                      Export
                    </Button>
                )}
                <Button
                  primary
                  onClick={() => {
                      this.props.submit(this.props.formData);

                      if (this.props.location.pathname !== this.props.redirectUrl) {
                          this.props.history.push(this.props.redirectUrl);
                      }
                  }}
                  loading={this.props.loading}>
                  <FormattedMessage id={this.props.searchButtonKey} />
                </Button>
              </Container>
            </div>
        );
    }
}

const getResourcePage = createResourcePageSelector(ResourceApi.Types.User);
const getSortOptions = createResourceSortOptionsSelector(ResourceApi.Types.User);

const mapStateToProps = state => {
  const {searchingUsers, currentQuery} = state.userManagement;
  const page = getResourcePage(state.resources);

  return {
    loading: searchingUsers,
    formData: currentQuery,
    sortOptions: getSortOptions(state),
    currentPage: page.page,
    count: page.count,
    onlySaveUnchanged: false
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  registerFields: registerFieldsAction,
  setQuery: setQueryAction,
  clearQuery: clearQueryAction,
  onValueChanged: (resourcePath, [field], value) => updateQueryAction(field, value),
  getResourcePage: getResourcePageAction
}, dispatch);

const UserSearchPanel = compose(
  setDisplayName('UserSearchPanel'),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => {
    const fields = props.formConfig.fields || props.formConfig.sections.reduce((result, section) => {
      return result.concat(section.fields);
    }, []);

    const emptyQuery = fields.reduce((formData, field) => {
      formData[field.name] = get(field, 'props.value', '');
      return formData;
    }, {});

    const queryIsEmpty = query => Object.keys(emptyQuery).every(field => query[field] === emptyQuery[field]);

    return {
      fields,
      submit: query => {
        if (!queryIsEmpty(query)) {
          props.setQuery(query);

          const filterOptions = filterOptionsFactory({
            filters: props.buildFilters(query)
          });

          props.getResourcePage(
            props.filterResource,
            props.count || 20,
            props.currentPage || 1,
            props.sortOptions,
            filterOptions
          );

          // FIXME: special handling for siteId field in search queries has been removed;
          //        can be restored once DBRKCP-8518 has been resolved. see git history.
        }
      }
    };
  })
)(SearchPanel);

export default UserSearchPanel;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserSearchPanel/UserSearchPanel.jsx